import React from 'react';
import { isUploadImageOverLimitError } from '../../util/errors';
import { FormattedMessage } from '../../util/reactIntl';
import css from './UploadError.css';

export default ({ uploadImageError }) => {
    const sizeLimitError =
        isUploadImageOverLimitError(uploadImageError) &&
        'ProfileSettingsForm.imageUploadFailedFileTooLarge';
    const uploadError = Boolean(uploadImageError) && 'ProfileSettingsForm.imageUploadFailed';

    return sizeLimitError || uploadError ? (
        <div className={css.error}>
            <FormattedMessage id={sizeLimitError || uploadError} />
        </div>
    ) : null;
};
